import React, { useState, useEffect } from 'react';
import axios from '../../httpServices/httpService';
import endPoint from '../../config.json';
import swal from 'sweetalert';
import valid from '../../utill/validation';
import joi from 'joi';
import Loading from '../../utill/LoadingComponent';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useHistory } from 'react-router-dom'

const UserRole = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [userGroup, setUserGroup] = useState({});
  const [oldObj, setOldObj] = useState({});
  const [errors, setErrors] = useState({});
  const [querySuccess, setQuerySuccess] = useState(false);

  const schema = {
    UserRole: joi.string().required()
  };

  useEffect(() => {
    if (location.state && location.state.action === 'add') {
      setUserGroup({});
    }
    if (location.state && location.state.action === 'update') {
      const userGroupData = { ...location.state.data };
      setUserGroup(userGroupData);
      setOldObj(userGroupData);
    }
  }, [location.state]);
  useEffect(() => {
    props.Heading('User Role Master')
  }, [])

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    const errorMessage = valid.validateProperty(e.target, schema);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage || ''
    }));

    setUserGroup((prevUserGroup) => ({
      ...prevUserGroup,
      [name]: value
    }));
  };

  const handleSubmit = (data) => {
    if (location.state && location.state.action === 'add') {
      const errors = valid.validate(data, schema);
      setErrors(errors || {});

      if (errors) return;

      setQuerySuccess(true);
      axios.post(`${endPoint.api}userrole`, data)
        .then((result) => {
          if (result.status === 200) {
            setQuerySuccess(false);
            history.push('/setting/userrole/list');
            swal('Data saved successfully');
          } else {
            setQuerySuccess(false);
            swal('Data not saved');
          }
        })
        .catch((err) => {
          setQuerySuccess(false);
          swal(`${err.response.data.message}`);
        });
    }

    if (location.state && location.state.action === 'update') {
      setQuerySuccess(true);

      axios.patch(`${endPoint.api}userrole/${data._id}`, { old: oldObj, new: data })
        .then((result) => {
          const { n, nModified, ok } = result.data;
          if (ok === 1 && n === 1 && nModified === 1) {
            setQuerySuccess(false);
            history.push('/setting/userrole/list');
            swal('Data updated successfully');
          } else {
            setQuerySuccess(false);
            swal(`${result.data}`);
          }
        })
        .catch((err) => {
          setQuerySuccess(false);
          toast.error(`${err}`, {
            position: 'bottom-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: 'red',
              color: 'white',
            },
          });
        });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {querySuccess && <Loading />}

      <div className="border">
        <div className="row justify-content-center">
          <div className="col-sm-4">
            <div className="form-group text-center">
              <label>User Role</label>
              <input
                type="text"
                className="form-control"
                placeholder="User Role"
                name="UserRole"
                onChange={handleOnChange}
                value={userGroup.UserRole || ''}
              />
              {errors.UserRole && (
                <div className="alert small alert-danger">{errors.UserRole}</div>
              )}
            </div>
          </div>
        </div>
        <div className="text-center">
          <button
            className="btn btn-primary"
            onClick={() => handleSubmit(userGroup)}
          >
            Submit
          </button>
        </div>
        <div className="text-center" style={{ marginTop: 10 }}>
          <button
            className="btn btn-primary"
            onClick={() => props.history.push('/setting/userrole/list')}
          >
            Cancel
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserRole;
